// extracted by mini-css-extract-plugin
module.exports = {"clockClass":"ClockClass_clockClass__22jW4","pTitle":"ClockClass_pTitle__1vFzH","pClock":"ClockClass_pClock__2Thja"};